const tourTemplate = require('../templates/bootstrap-tour.html');
const bemVindoTemplate = require('../templates/bem-vindo.html');
const template = require('lodash/template');
const makeDropdown = require('../functions/makeDropdown');
const isMobile = require('is-mobile');
require('bootstrap-tour');
const Lang = require('lang');

exports.init = function() {

  const dropdown = $('#dropdown-user');
  const user_name = current_user.nome + current_user.id;

  $('html, body').addClass('no-scroll');

  const tour = new Tour({
    name: user_name,
    template: tourTemplate,
    orphan: true,
    steps: [{
      element: '[data-step=0]',
      content: Lang.get('js/src/tutorials/HomeTutorial.this_is_menu_bar'),
      placement: 'bottom',
    }, {
      element: '[data-step=1]',
      content: Lang.get('js/src/tutorials/HomeTutorial.expenses_visualization'),
      placement: 'bottom',
    }, {
      element: '[data-step=2]',
      content: Lang.get('js/src/tutorials/HomeTutorial.reports'),
      placement: 'bottom',
    }, {
      element: '[data-step=3]',
      content: Lang.get('js/src/tutorials/HomeTutorial.user_approvals'),
      placement: 'bottom',
    }, {
      element: '[data-step=4]',
      content: Lang.get('js/src/tutorials/HomeTutorial.filters_section'),
      placement: 'right',
      onShow: function(tour) {
        const stepElement = $(getTourElement(tour, 4));
        stepElement.closest('.actions-container').addClass('actions-container--absolute');
      }
    }, {
      element: '[data-step=5]',
      content: Lang.get('js/src/tutorials/HomeTutorial.action_area'),
      placement: 'top',
      onShow: function(tour) {
        const stepElement = $(getTourElement(tour, 5));
        stepElement.closest('.actions-container').addClass('actions-container--absolute');
      },
      onHide: function(tour) {
        const stepElement = $(getTourElement(tour));
        stepElement.closest('.actions-container').removeClass('actions-container--absolute');
      }
    }, {
      element: '[data-step=6]',
      content: Lang.get('js/src/tutorials/HomeTutorial.finish_inserting_data'),
      placement: 'left',
      onShow: function(tour) {
        dropdown.addClass('open');
      }
    }, {
      element: '[data-step=7]',
      content: Lang.get('js/src/tutorials/HomeTutorial.backoffice_register_projects'),
      placement: 'left',
      onHide: function(tour) {
        dropdown.removeClass('open');
      }
    }, {
      content: Lang.get('js/src/tutorials/HomeTutorial.thank_you_to_follow_tutorial')
    }],
    backdrop: true,
    onEnd: function() {
      $('html, body').removeClass('no-scroll');
      makeDropdown(dropdown);
    },
    onShown: function(tour) {
      const stepElement = $(getTourElement(tour));
      stepElement.after($('.tour-step-background'));
      stepElement.after($('.tour-backdrop'));
    }
  });


  if (tourWillStart(user_name) && !isMobile()) {
    bootbox.dialog({
      title: Lang.get('js/src/tutorials/HomeTutorial.welcome_vexpenses'),
      className: 'first-login-modal',
      message: template(bemVindoTemplate)({ email: current_user.email }),
      size: null,
      closeButton: false,
      buttons: {
        cancel: {
          label: Lang.get('js/src/tutorials/HomeTutorial.no_thanks'),
          callback: function() {
            $('html, body').removeClass('no-scroll');
            makeDropdown(dropdown);
          }
        },
        confirm: {
          label: Lang.get('js/src/tutorials/HomeTutorial.lets_go'),
          callback: function() {
            $('html, body').addClass('no-scroll');
            tour.init().start();
          }
        }
      }
    });
  } else {
    makeDropdown(dropdown)
  }
}

exports.url = '/despesas';

function getTourElement(tour, step) {
  step = typeof step === 'undefined' ? tour._current : step;
  return tour._options.steps[step].element
}

function tourWillStart(name) {
  name = name || 'tour';
  const a = !(localStorage.getItem(name + '_end') == 'yes');
  return a;
}

// Por favor confirme sua conta, enviamos um email de confirmação para {email}. Você também pode clicar aqui para receber novamente.
